import { PaysafeFieldConfig } from './paysafe-field-config.interface';
import { PaysafeFormField } from './paysafe-form-field.enum';

export interface PaysafeCvvFieldConfig extends PaysafeFieldConfig {
  fieldName: PaysafeFormField.Cvv;
  mask: boolean;
}
